export default __webpack_public_path__ + "static/media/point-unknown.2d1a2156.svg";